import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchBookings } from '@/renderer/services/accommodationService';
import type { BookingFilters } from '@/renderer/types/accommodation';

export function useBookings(
  propertyId: string | null | undefined,
  filters?: BookingFilters,
) {
  return useQuery({
    queryKey: queryKeys.accommodation.bookings(propertyId ?? '', filters),
    queryFn: () => fetchBookings(propertyId!, filters),
    enabled: !!propertyId,
    placeholderData: keepPreviousData,
  });
}
